import { Google } from '../analytics/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';

/**
 * @summary Sends Google event for custom order button in Compare Trims link in MMT filter group
 * @events event40
 */
export async function customOrderYours(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    makeId,
    makeName,
    inheritPageData
  } = metadata.data;
  const vehicleData = googleInventoryTransformer({}, {
    target: 'vehicle'
  }, inheritPageData);
  Google.sendClickEvent({
    eventElement: 'element',
    eventResult: 'text-link::open::custom-order-yours',
    eventData: {
      vehicle: {
        ...vehicleData,
        description: makeId,
        sellerType: makeName
      }
    }
  }, option);
  return {};
}

/**
 * @summary Sends an Google link track information helpful feedback buttons
 * @events event41
 */
export function informationHelpful(metadata, option) {
  const {
    label
  } = metadata.data;
  Google.sendClickEvent({
    eventElement: 'compare',
    eventResult: `information-helpful::${label}`
  }, option);
  return {};
}

/**
 * @summary Sends an Google link track for Compare trim button click
 * @events event42
 */
export function compareTrimsClick(metadata, option) {
  Google.sendClickEvent({
    eventElement: 'compare',
    eventResult: 'text-link::open::compare-trim'
  }, option);
  return {};
}
export default {
  customOrderYours,
  informationHelpful,
  compareTrimsClick
};